const formatter = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });

/** A save time in the reader's locale, for example “Sep 24, 2026, 12:17 AM”. */
export function formatSavedAt(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? 'unknown time' : formatter.format(date);
}
